import { PolyRender } from "@evergis/sgis/es/renders/Poly";
import { Coordinates } from "@evergis/sgis/es/baseTypes";
import { Polygon } from "@evergis/sgis/es/features/Polygon";
import { EditorPolySymbolParams, ShadowedPolySymbol } from "../editorSymbols/ShadowedPolySymbol";

type SelectedFeature = Polygon & {
  isSelected: boolean;
};

export type SelectedPolySymbolParams = {
  selectedFillColor?: string;
  selectedStrokeColor: string;
  selectedStrokeWidth?: number;
} & EditorPolySymbolParams;

export class SelectedPolySymbol extends ShadowedPolySymbol {
  selectedFillColor!: string;

  selectedStrokeColor!: string;

  selectedStrokeWidth: number;

  constructor(options: SelectedPolySymbolParams) {
    super(options);
  }

  protected getShadow(
    coordinates: Coordinates[][],
    feature: SelectedFeature,
    mapCoordinates: Coordinates[][],
  ): PolyRender | void {
    if (feature.isSelected) {
      return super.getShadow(coordinates, feature, mapCoordinates);
    }
  }

  protected getPolyRender(
    coordinates: Coordinates[][],
    feature: SelectedFeature,
    mapCoordinates: Coordinates[][],
  ): PolyRender {
    const polyRender = super.getPolyRender(coordinates, feature, mapCoordinates);

    if (feature.isSelected) {
      polyRender.fillColor = this.selectedFillColor;
      polyRender.strokeColor = this.selectedStrokeColor;
      if (this.selectedStrokeWidth !== void 0) {
        polyRender.strokeWidth = this.selectedStrokeWidth;
      }
    }

    return polyRender;
  }
}
